import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { isInstalledApp, isIOS } from 'app/main/utils/installedApp';
import useInstallPrompt from 'app/main/utils/useInstallPrompt';

const DISMISSED_KEY = 'install_app_prompt_dismissed';

const wasDismissed = () => {
  try {
    return Boolean(localStorage.getItem(DISMISSED_KEY));
  } catch (error) {
    return false;
  }
};

function InstallAppPrompt() {
  const role = useSelector(({ auth }) => auth.user.role);
  const { installPrompt, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(wasDismissed);

  const isLoggedIn = Array.isArray(role) ? role.length > 0 : Boolean(role);
  const showIOSHint = isIOS() && !installPrompt;
  if (!isLoggedIn || dismissed || isInstalledApp() || (!installPrompt && !showIOSHint)) {
    return null;
  }

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch (error) {
      // Without storage the prompt simply comes back next visit.
    }
    setDismissed(true);
  };

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <SnackbarContent
        message={
          showIOSHint ? (
            <span>
              Install iCentral: tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
            </span>
          ) : (
            'Install iCentral on this device for quick access from your home screen.'
          )
        }
        action={
          <>
            {!showIOSHint && (
              <Button color="secondary" size="small" onClick={install}>
                Install
              </Button>
            )}
            <IconButton size="small" color="inherit" aria-label="Dismiss" onClick={dismiss}>
              <Icon fontSize="small">close</Icon>
            </IconButton>
          </>
        }
      />
    </Snackbar>
  );
}

export default InstallAppPrompt;
